import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BilingualText } from '../components/BilingualText';
import { ArrowLeft, Save, Trash2, Plus, Calendar as CalendarIcon } from 'lucide-react';
export function CapacitySettings() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-400">
      <header className="bg-white px-4 py-6 border-b border-slate-100 flex items-center justify-between sticky top-0 z-10 lg:px-8" data-id="element-401">
        <div className="flex items-center gap-4" data-id="element-402">
          <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-403">
            <ArrowLeft size={24} data-id="element-404" />
          </button>
          <BilingualText en="Capacity Settings" ar="إعدادات السعة" className="text-xl font-bold" data-id="element-405" />
        </div>
        <button className="btn-primary py-2 px-4 text-sm" data-id="element-406">
          <Save size={18} data-id="element-407" />
          <span data-id="element-408">Save Changes</span>
        </button>
      </header>

      <main className="p-4 space-y-6 max-w-3xl mx-auto" data-id="element-409">
        <section className="space-y-4" data-id="element-410">
          <BilingualText en="Default Daily Capacity" ar="السعة اليومية الافتراضية" className="text-xl" data-id="element-411" />
          <div className="card p-6 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-412">
            <div className="space-y-2" data-id="element-413">
              <BilingualText en="Max Shipments" ar="أقصى عدد شحنات" subtle data-id="element-414" />
              <input type="number" defaultValue={50} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-lg font-bold" data-id="element-415" />
            </div>
            <div className="space-y-2" data-id="element-416">
              <BilingualText en="Max Cartons" ar="أقصى عدد كراتين" subtle data-id="element-417" />
              <input type="number" defaultValue={2500} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-lg font-bold" data-id="element-418" />
            </div>
            <div className="space-y-2" data-id="element-419">
              <BilingualText en="Max Pallets" ar="أقصى عدد طبالي" subtle data-id="element-420" />
              <input type="number" defaultValue={100} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-lg font-bold" data-id="element-421" />
            </div>
          </div>
        </section>

        <section className="space-y-4" data-id="element-422">
          <div className="flex items-center justify-between" data-id="element-423">
            <BilingualText en="Capacity Overrides" ar="تجاوزات السعة" className="text-xl" data-id="element-424" />
            <button className="btn-secondary py-2 px-4 text-sm" data-id="element-425">
              <Plus size={18} data-id="element-426" />
              <span data-id="element-427">Add Override</span>
            </button>
          </div>
          <div className="space-y-3" data-id="element-428">
            <OverrideItem date="July 15, 2026" reason="Staff Shortage" shipments={30} cartons={1500} pallets={60} data-id="element-429" />
            <OverrideItem date="July 23, 2026" reason="Public Holiday" shipments={0} cartons={0} pallets={0} data-id="element-430" />
          </div>
        </section>
      </main>
    </div>;
}
function OverrideItem({
  date,
  reason,
  shipments,
  cartons,
  pallets
}: any) {
  return <div className="card p-4 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-431">
      <div className="flex items-center gap-4" data-id="element-432">
        <div className="p-3 bg-blue-50 text-[#2E3192] rounded-lg" data-id="element-433">
          <CalendarIcon size={20} data-id="element-434" />
        </div>
        <div data-id="element-435">
          <div className="font-bold" data-id="element-436">{date}</div>
          <div className="text-sm text-slate-500" data-id="element-437">{reason}</div>
        </div>
      </div>
      <div className="flex items-center gap-6 text-sm" data-id="element-438">
        <div className="text-center" data-id="element-439">
          <div className="text-slate-400" data-id="element-440">Shipments</div>
          <div className="font-bold" data-id="element-441">{shipments}</div>
        </div>
        <div className="text-center" data-id="element-442">
          <div className="text-slate-400" data-id="element-443">Cartons</div>
          <div className="font-bold" data-id="element-444">{cartons}</div>
        </div>
        <div className="text-center" data-id="element-445">
          <div className="text-slate-400" data-id="element-446">Pallets</div>
          <div className="font-bold" data-id="element-447">{pallets}</div>
        </div>
        <button className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors" data-id="element-448">
          <Trash2 size={18} data-id="element-449" />
        </button>
      </div>
    </div>;
}